import React from 'react';
import { Link } from 'react-router-dom';
import { CloseRounded } from '@mui/icons-material';

import { Button } from '@mui/material';
import {
  CloseButtonWrapper,
  LargeLogo,
  LogoWrapper,
} from './logo-section.style';

function LogoSection({
  homePath,
  onCloseSidebarClick,
}: {
  homePath: string;
  onCloseSidebarClick: () => void;
}): JSX.Element {
  return (
    <LogoWrapper>
      <>
        <CloseButtonWrapper>
          <Button
            onClick={() => onCloseSidebarClick()}
            endIcon={<CloseRounded />}
            variant="text"
            color="primary"
            size="small"
          />
        </CloseButtonWrapper>
        <Link to={homePath}>
          <LargeLogo />
        </Link>
      </>
    </LogoWrapper>
  );
}

export { LogoSection };
